module.exports = __webpack_public_path__ + "img/donut.febfd6ae.svg";